interface IconProps {
  className?: string;
  color?: string;
}

// Technico-commercial - Personne avec graphique
export function TechnicoCommercialIcon({ className = "w-12 h-12", color = "#EA580C" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Tête */}
      <circle cx="45" cy="28" r="7" fill={color} opacity="0.15" />
      <circle cx="45" cy="28" r="7" fill="none" stroke={color} strokeWidth="2.5" />

      {/* Corps */}
      <path d="M 45 35 L 45 55" stroke={color} strokeWidth="3" strokeLinecap="round" />

      {/* Bras */}
      <path d="M 45 42 L 35 45" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      <path d="M 45 42 L 55 38" stroke={color} strokeWidth="2.5" strokeLinecap="round" />

      {/* Jambes */}
      <path d="M 45 55 L 40 68" stroke={color} strokeWidth="3" strokeLinecap="round" />
      <path d="M 45 55 L 50 68" stroke={color} strokeWidth="3" strokeLinecap="round" />

      {/* Graphique/Tablette */}
      <rect x="55" y="30" width="25" height="35" fill="white" stroke={color} strokeWidth="2.5" rx="2" />

      {/* Graphique en barres */}
      <rect x="60" y="50" width="4" height="10" fill={color} opacity="0.3" />
      <rect x="66" y="45" width="4" height="15" fill={color} opacity="0.5" />
      <rect x="72" y="40" width="4" height="20" fill={color} opacity="0.7" />
    </svg>
  );
}

// Conseiller agricole - Personne avec presse-papiers
export function ConseillerAgricoleIcon({ className = "w-12 h-12", color = "#EA580C" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Presse-papiers */}
      <rect x="35" y="25" width="30" height="40" fill={color} opacity="0.15" rx="2" />
      <rect x="35" y="25" width="30" height="40" fill="none" stroke={color} strokeWidth="2.5" rx="2" />

      {/* Clip du presse-papiers */}
      <rect x="45" y="20" width="10" height="6" fill={color} opacity="0.3" rx="2" />
      <rect x="45" y="20" width="10" height="6" fill="none" stroke={color} strokeWidth="2" rx="2" />

      {/* Lignes de texte */}
      <line x1="40" y1="35" x2="60" y2="35" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <line x1="40" y1="42" x2="55" y2="42" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <line x1="40" y1="49" x2="60" y2="49" stroke={color} strokeWidth="2" strokeLinecap="round" />

      {/* Checkboxes */}
      <rect x="40" y="53" width="5" height="5" fill="none" stroke={color} strokeWidth="1.5" rx="1" />
      <path d="M 41 56 L 42.5 57.5 L 44.5 54.5" stroke={color} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />

      <rect x="40" y="60" width="5" height="5" fill="none" stroke={color} strokeWidth="1.5" rx="1" />

      {/* Crayon */}
      <rect x="62" y="45" width="4" height="20" fill={color} opacity="0.5" rx="1" transform="rotate(-30 64 55)" />
      <path d="M 70 60 L 67 63 L 73 65 Z" fill={color} transform="rotate(-30 70 62)" />
    </svg>
  );
}

// Agronome - Plant avec feuilles et loupe
export function AgronomeIcon({ className = "w-12 h-12", color = "#EA580C" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Tige de la plante */}
      <path d="M 45 70 Q 45 50, 45 35" stroke={color} strokeWidth="3" fill="none" strokeLinecap="round" />

      {/* Feuilles gauche */}
      <ellipse cx="35" cy="50" rx="8" ry="12" fill={color} opacity="0.2" transform="rotate(-30 35 50)" />
      <ellipse cx="35" cy="50" rx="8" ry="12" fill="none" stroke={color} strokeWidth="2" transform="rotate(-30 35 50)" />

      <ellipse cx="38" cy="40" rx="7" ry="10" fill={color} opacity="0.2" transform="rotate(-40 38 40)" />
      <ellipse cx="38" cy="40" rx="7" ry="10" fill="none" stroke={color} strokeWidth="2" transform="rotate(-40 38 40)" />

      {/* Feuilles droite */}
      <ellipse cx="55" cy="55" rx="8" ry="12" fill={color} opacity="0.2" transform="rotate(30 55 55)" />
      <ellipse cx="55" cy="55" rx="8" ry="12" fill="none" stroke={color} strokeWidth="2" transform="rotate(30 55 55)" />

      <ellipse cx="52" cy="45" rx="7" ry="10" fill={color} opacity="0.2" transform="rotate(40 52 45)" />
      <ellipse cx="52" cy="45" rx="7" ry="10" fill="none" stroke={color} strokeWidth="2" transform="rotate(40 52 45)" />

      {/* Pot */}
      <path d="M 35 70 L 38 78 L 52 78 L 55 70 Z" fill={color} opacity="0.15" />
      <path d="M 35 70 L 38 78 L 52 78 L 55 70 Z" fill="none" stroke={color} strokeWidth="2.5" />

      {/* Loupe */}
      <circle cx="65" cy="35" r="10" fill="white" stroke={color} strokeWidth="2.5" />
      <circle cx="65" cy="35" r="6" fill="none" stroke={color} strokeWidth="2" />
      <line x1="72" y1="42" x2="78" y2="48" stroke={color} strokeWidth="2.5" strokeLinecap="round" />

      {/* Détail dans la loupe */}
      <line x1="62" y1="35" x2="68" y2="35" stroke={color} strokeWidth="1.5" opacity="0.5" />
      <line x1="65" y1="32" x2="65" y2="38" stroke={color} strokeWidth="1.5" opacity="0.5" />
    </svg>
  );
}
